var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-to-cart 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.3448 25.2515L23.6306 10.2369C23.459 8.7196 22.1789 7.57538 20.6536 7.57538H20.099V6.50288C20.099 3.6946 17.8083 1.40991 14.9929 1.40991C12.1847 1.40991 9.89998 3.6946 9.89998 6.50288V7.57538H9.34545C7.8206 7.57538 6.54092 8.7196 6.36842 10.2365L4.65467 25.2543C4.56092 26.1299 4.81638 26.9385 5.40138 27.6027C5.99998 28.2487 6.77154 28.5899 7.63217 28.5899H22.3683C23.2289 28.5899 23.9995 28.2487 24.6061 27.5938C25.1831 26.9385 25.439 26.1294 25.3448 25.2515ZM10.8379 6.50288C10.8379 4.21163 12.7022 2.34741 14.9934 2.34741C17.2917 2.34741 19.162 4.21163 19.162 6.50288V7.57538H10.8379V6.50288ZM23.9109 26.9657C23.4886 27.4213 22.9692 27.6524 22.3683 27.6524H7.63217C7.03076 27.6524 6.51138 27.4213 6.09701 26.9741C5.69295 26.5152 5.52092 25.9701 5.58654 25.3574L7.30029 10.3424C7.41888 9.29944 8.29873 8.51288 9.34592 8.51288H9.90045V11.0873C9.90045 11.346 10.11 11.556 10.3692 11.556C10.6284 11.556 10.8379 11.346 10.8379 11.0873V8.51288H19.162V11.0873C19.162 11.346 19.3715 11.556 19.6308 11.556C19.89 11.556 20.0995 11.346 20.0995 11.0873V8.51288H20.654C21.7017 8.51288 22.5811 9.29944 22.6997 10.3429L24.4134 25.3546C24.479 25.9696 24.3075 26.5148 23.9109 26.9657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4254 18.2452H15.4622V16.2957C15.4622 16.0369 15.2527 15.8269 14.9935 15.8269C14.7343 15.8269 14.5247 16.0369 14.5247 16.2957V18.2452H12.5752C12.316 18.2452 12.1064 18.4552 12.1064 18.7139C12.1064 18.9727 12.316 19.1827 12.5752 19.1827H14.5247V21.1458C14.5247 21.4046 14.7343 21.6146 14.9935 21.6146C15.2527 21.6146 15.4622 21.4046 15.4622 21.1458V19.1827H17.4254C17.6846 19.1827 17.8941 18.9727 17.8941 18.7139C17.8941 18.4552 17.6841 18.2452 17.4254 18.2452Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart);
export default __webpack_public_path__ + "static/media/add-to-cart.edc34c7626f4ff0cea89a83e41e0f7a1.svg";
export { ForwardRef as ReactComponent };